import Marquee from "react-fast-marquee";

const ITEMS = [
  "Aarmira — Fashion & Fortune",
  "Genuine Gemstones",
  "Handcrafted in India",
  "Luxury Imitation & Fine Fashion",
  "Secure Razorpay Checkout",
];

const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-gold/30 bg-cream-dark py-5"
  >
    <Marquee speed={25} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif text-sm uppercase tracking-[0.25em] text-espresso/80">
            {item}
          </span>
          <span className="mx-10 inline-block h-1.5 w-1.5 rotate-45 bg-gold-accent" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
